import { AbstractMaterialFactory } from "oc-threejs/loader/AbstractMaterialFactory";

export class SceneWkfg2Importer extends AbstractMaterialFactory {
  constructor(texture_root: string) {
    super(texture_root, null);
  }

  getAllKnownMaterialNames(): string[] {
    return [];
  }

  _createMaterial(materialName: string) {
    return null;
  }
}
